import {
  NextWorkingDayActionActions,
  NextWorkingDayActionTypes,
} from '../../../shared/modules/common-specification/actions/next-working-day.actions';

export interface NextWorkingDayState {
  loading: boolean;
  nextWorkingDay: Date;
}

export const initialState: NextWorkingDayState = {
  loading: false,
  nextWorkingDay: null,
};

export function reducer(state = initialState, action: NextWorkingDayActionActions): NextWorkingDayState {
  switch (action.type) {
    case NextWorkingDayActionTypes.LOAD: {
      return {
        ...state,
        loading: true,
      } as NextWorkingDayState;
    }
    case NextWorkingDayActionTypes.LOAD_COMPLETE: {
      return {
        ...state,
        loading: false,
        nextWorkingDay: action.payload.date,
      } as NextWorkingDayState;
    }
    default: {
      return state;
    }
  }
}
